import React, { useState } from 'react'
import Swal from 'sweetalert2'
import copy from 'copy-to-clipboard'
import { axiosClientAuth } from '../../../utils/axiosClient'
import { KTIcon } from '../../../../_metronic/helpers'

const ContactUs = () => {
  const [input, setInput] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    phone: '1234567890',
  })

  const handleCopy = (text) => {
    copy(text);
    Swal.fire({
      title: 'Copied',
      text: 'The text has been copied to your clipboard.',
      icon: 'success',
    })
  }
  const onChangeHand = (e) => {
    setInput((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const submitHand = (e) => {
    e.preventDefault()

    axiosClientAuth
      .post('/common/contact-us', input)
      .then((resp) => {
        Swal.fire({
          title: 'Feedback Submitted',
          text: 'Your feedback has been submitted successfully.',
          icon: 'success',
        }).then(result => {
          window.location.reload()
        })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  return (
    <div className='card'>
      <div className='card-body p-lg-17'>
        <div className='row mb-3'>
          <div className='col-md-6 pe-lg-10'>
            <form className='form mb-15' id='kt_contact_form' onSubmit={submitHand}>
              <h1 className='fw-bold text-dark mb-9'>Contact Us</h1>
              <div className='row mb-5'>
                <div className='col-md-6 fv-row'>
                  <label className='fs-5 fw-semibold mb-2'>Name</label>
                  <input
                    type='text'
                    className='form-control form-control-solid'
                    placeholder=''
                    name='name'
                    value={input.name}
                    onChange={onChangeHand}
                  />
                </div>
                <div className='col-md-6 fv-row'>
                  <label className='fs-5 fw-semibold mb-2'>Email Id</label>
                  <input
                    type='text'
                    className='form-control form-control-solid'
                    placeholder=''
                    name='email'
                    value={input.email}
                    onChange={onChangeHand}
                  />
                </div>
              </div>
              <div className='d-flex flex-column mb-5 fv-row'>
                <label className='fs-5 fw-semibold mb-2'>Subject</label>
                <input
                  className='form-control form-control-solid'
                  placeholder=''
                  name='subject'
                  value={input.subject}
                  onChange={onChangeHand}
                />
              </div>
              <div className='d-flex flex-column mb-10 fv-row'>
                <label className='fs-6 fw-semibold mb-2'>Message</label>
                <textarea
                  className='form-control form-control-solid'
                  rows={6}
                  name='message'
                  placeholder=''
                  value={input.message}
                  onChange={onChangeHand}
                />
              </div>
              <button type='submit' className='btn btn-primary' id='kt_contact_submit_button'>
                <span className='indicator-label'>Send Feedback</span>
                <span className='indicator-progress'>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2' />
                </span>
              </button>
            </form>
          </div>
          <div className='col-sm-6 pe-lg-10'>
            <div className='text-center bg-light card-rounded d-flex flex-column justify-content-center p-10 mb-10'>
              <h1 className='text-dark fw-bold my-5'>Let’s Speak</h1>
              <div className='text-gray-700 fw-semibold fs-2'>+91 8956893799</div>
              <div className='text-gray-500 fw-semibold fs-5'>( IST - 8 AM to 8 PM )</div>
            </div>
            <div className="card bg-light rounded text-center p-4 d-flex flex-column gap-5">
              <h1 className="text-dark fw-bold">Write Us</h1>

              <div className="d-flex flex-column gap-4 text-start">
                {/* Goflipo Panel Support */}
                <div className="d-flex justify-content-between align-items-center flex-wrap border-bottom pb-3">
                  <div>
                    <h2 className="text-dark fw-bold fs-4 mb-1">Goflipo Panel Support:</h2>
                    <p className="text-gray-700 fs-5 fw-semibold m-0">support@goflipo.com</p>
                  </div>
                  <span onClick={() => handleCopy("support@goflipo.com")} className="cursor-pointer">
                    <KTIcon iconName="copy" className="ms-3 fs-4" />
                  </span>
                </div>

                {/* Technical Support */}
                <div className="d-flex justify-content-between align-items-center flex-wrap border-bottom pb-3">
                  <div>
                    <h2 className="text-dark fw-bold fs-4 mb-1">Technical Support:</h2>
                    <p className="text-gray-700 fs-5 fw-semibold m-0">support@goflipo.com</p>
                  </div>
                  <span onClick={() => handleCopy("support@goflipo.com")} className="cursor-pointer">
                    <KTIcon iconName="copy" className="ms-3 fs-4" />
                  </span>
                </div>
              </div>
            </div>

            {/* <div className='text-center bg-light card-rounded d-flex flex-column justify-content-center p-10'>
              <span>
                <i className='ki-duotone ki-geolocation fs-4x text-primary'>
                  <i className='path1'></i>
                  <i className='path2'></i>
                </i>
              </span>
              <h1 className='text-dark fw-bold my-5'>Goflipo Head Office</h1>
              <div className='text-gray-700 fs-3 fw-semibold'>
                Goflipo Bhawan, GK-I,
                <br />
                New Delhi-110048
              </div>
            </div> */}
          </div>
          <div className='col-sm-6 ps-lg-10'></div>
        </div>
        <div className='row g-5 mb-5 mb-lg-15'></div>
      </div>
    </div>
  )
}

export default ContactUs